import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgConnectionNetworkIcon = ({
  title,
  theme = null,
  titleId = "",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path d="M19.4 38.8a1 1 0 0 0 1.2-1.6 19 19 0 1 1 22.8 0 1 1 0 0 0 1.2 1.6 21 21 0 1 0-25.2 0Z" />
      <circle cx={32} cy={22} r={10} />
      <path
        d="M48 49.1V46a1 1 0 0 0-.586-.91l-10.482-4.765a4.975 4.975 0 0 0-9.864 0L16.586 45.09A1 1 0 0 0 16 46v3.1a5 5 0 1 0 2 0v-2.456l9.238-4.2A5 5 0 0 0 31 45.9v7.2a5 5 0 1 0 2 0v-7.2a5 5 0 0 0 3.762-3.454L46 46.644V49.1a5 5 0 1 0 2 0Z"
        data-color="color-2"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgConnectionNetworkStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgConnectionNetworkIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ConnectionNetworkIcon: any = SvgConnectionNetworkStyle;
export default ConnectionNetworkIcon;
